document.addEventListener('DOMContentLoaded', function() {
  // Initialize Add to Cart buttons
  initAddToCartButtons();

  // Update cart counts on page load (fixes stuck count after logout)
  updateViewCartButtons();
  updateHeaderCartCount();
});

// ====================== ADD TO CART ======================
function initAddToCartButtons() {
  const variantCards = document.querySelectorAll('.variant-card');
  if (variantCards.length === 0) return;

  variantCards.forEach(function(card) {
    const button = card.querySelector('.add-to-cart-btn');
    const qtyInput = card.querySelector('.quantity-input');

    if (!button) return;
    if (card.dataset.atcBound) return;
    card.dataset.atcBound = '1';

    button.addEventListener('click', function() {
      const variantId = parseInt(button.getAttribute('data-variant-id'));
      const quantity = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;

      button.disabled = true;
      const originalText = button.textContent;
      button.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity }]
        })
      })
      .then(response => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(() => {
        button.textContent = 'Classy!';

        // Update both View Cart buttons and header cart count
        updateViewCartButtons();
        updateHeaderCartCount();

        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1800);
      })
      .catch(error => {
        console.error(error);
        alert('Error adding to cart. Please try again.');
        button.textContent = originalText;
        button.disabled = false;
      });
    });
  });
}

// ====================== UPDATE VIEW CART BUTTONS ======================
function updateViewCartButtons() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const count = cart.item_count || 0;
      const buttons = document.querySelectorAll('.view-cart-btn');

      buttons.forEach(function(btn) {
        btn.innerHTML = `
          View Cart 
          ${count > 0 ? `<span class="cart-count-badge">${count}</span>` : ''}
        `;
      });
    })
    .catch(err => console.error('Failed to update View Cart buttons', err));
}

// ====================== UPDATE HEADER CART COUNT ======================
function updateHeaderCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const bubble = document.querySelector('.cart-count-bubble') || 
                     document.querySelector('#cart-icon-bubble .cart-count-bubble');

      if (!bubble) return;

      if (cart.item_count > 0) {
        bubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;
        bubble.style.display = '';
      } else {
        bubble.style.display = 'none';
      }
    })
    .catch(err => console.error('Failed to update header cart count', err));
}